import React, { useState, useEffect } from "react";
import closeIcon from "../../../../../Assets/images/close-icon.svg";

const ReasonModal = ({ id, show, title = "Disable", onCancel, onDisable }) => {
  const [reason, setReason] = useState(""), [error, setError] = useState("");

  useEffect(() => {
    if (!show) { setReason(""); setError(""); }
  }, [show]);

  const handleChange = e => {
    setReason(e.target.value);
    if (error && e.target.value.trim()) setError("");
  };

  const handleDisable = () => {
    if (!reason.trim()) { setError("Reason is required."); return; }
    onDisable(reason.trim());
  };

  return (
    <div className={`modal fade ${show ? "show d-block" : ""}`} id={id} tabIndex="-1"
      aria-hidden={!show} style={{ backgroundColor: show ? "rgba(0,0,0,0.15)" : "transparent" }}>
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content setm-content">
          <div className="modal-body stem-body">
            <div className="am-head del-head">
              <h2>{title}</h2>
              <button type="button" onClick={onCancel}><img src={closeIcon} alt="Close" /></button>
            </div>
            <label className="fi-label mt-2">Reason:<span>*</span></label>
            <textarea
              className={`common-text ${error ? "error" : ""}`}
              value={reason}
              onChange={handleChange}
              placeholder="Enter reason..."
            />
            {error && <span className="error-text active" style={{position:'relative' , bottom:'0'}}>{error}</span>}
            <div className="reason-btn">
              <button className="btn btn-secondary" onClick={onCancel}>Cancel</button>
              <button className="btn btn-danger" onClick={handleDisable}>Disable</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReasonModal;
